'use client';

import dayjs from 'dayjs';
// import { useEffect, useCallback } from 'react';
import { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { notify } from 'src/utils/helper';
import { USER_ID_STORAGE_KEY } from 'src/utils/constants';

import { useChangeLanguagePref } from 'src/api/useProfile';

import { useSettingsContext } from 'src/components/settings';

// import { useAuthContext } from 'src/auth/hooks';
import { fallbackLng, getCurrentLang } from './locales-config';

// ----------------------------------------------------------------------

export function useTranslate(namespace) {
  const settings = useSettingsContext();
  const { mutateAsync: postLanguagePref } = useChangeLanguagePref();
  // const { user } = useAuthContext();
  const user = JSON.parse(sessionStorage.getItem('user'));
  const userID = localStorage.getItem(USER_ID_STORAGE_KEY);

  const { t, i18n } = useTranslation(namespace);
  const { t: tMessages } = useTranslation('messages');

  const currentLang = getCurrentLang(i18n.resolvedLanguage);

  const updateDirection = useCallback(
    (lang) => {
      settings.setState({ direction: i18n.dir(lang) });
    },
    [i18n, settings]
  );

  const updateDayjsLocale = useCallback((lang) => {
    const updatedLang = getCurrentLang(lang);
    dayjs.locale(updatedLang.adapterLocale);
  }, []);

  const handleChangeLang = useCallback(
    async (lang) => {
      try {
        postLanguagePref({
          defaultLang: lang,
          token: user?.token,
          userID,
        }).then(async (res) => {
          const changeLangPromise = i18n.changeLanguage(lang);
          await changeLangPromise;
          if (res?.success) {
            notify('success', res?.success);
            updateDirection(lang);
            updateDayjsLocale(lang);
            window.location.reload();
          }

          if (res?.error) {
            notify('error', res?.success);
            updateDirection(lang);
            updateDayjsLocale(lang);
            window.location.reload();
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    [i18n, tMessages, updateDayjsLocale, updateDirection]
  );

  const updateLang = (lang) => {
    postLanguagePref({
      defaultLang: lang,
      token: user?.token,
      userID,
    }).then(async (res) => {});
  };

  const handleResetLang = useCallback(() => {
    handleChangeLang(fallbackLng);
  }, [handleChangeLang]);

  return {
    t,
    i18n,
    currentLang,
    onChangeLang: handleChangeLang,
    onResetLang: handleResetLang,
    updateLangOnServer: updateLang,
  };
}

// ----------------------------------------------------------------------

export function useLocaleDirectionSync() {
  const { i18n, currentLang } = useTranslate();
  const { state, setState } = useSettingsContext();

  const handleSync = useCallback(async () => {
    if (state.direction !== i18n.dir(currentLang.value)) {
      setState({ direction: i18n.dir(currentLang.value) });
    }

    if (i18n.resolvedLanguage !== currentLang.value) {
      await i18n.changeLanguage(currentLang.value);
    }
  }, [currentLang.value, i18n, setState, state.direction]);

  useEffect(() => {
    handleSync();
  }, [handleSync]);

  return null;
}
